import { createAsyncThunk } from '@reduxjs/toolkit';
import axiosPrivate from 'config/axiosPrivate';

export const fetchWebsiteDisplay = createAsyncThunk(
  'clientWebsiteDetails/fetchWebsiteDisplay',
  async (arg, thunkAPI) => {
    try {
      const response = await axiosPrivate.get('/user/myWebsites');
      if (response.status === 200) {
        return response.data;
      }
      return thunkAPI.rejectWithValue(response.status);
    } catch (e) {
      return thunkAPI.rejectWithValue(e.response.data);
    }
  }
);
